/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { findDOMNode } from 'react-dom'
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { DragSource } from 'react-dnd'

import { TableRow, TableCell, Tooltip, IconButton, CircularProgress, Menu, MenuItem, Typography, Card, CardActionArea, CardContent, CardActions } from '@material-ui/core'
import { Bookmark, BookmarkBorder, ChangeHistory, MoreVert, Star, SyncProblem } from '@material-ui/icons'

import RecordIcon from './RecordIcon'
import GroupIcon from '../Groups/GroupIcon';
import SingletonIcon from '../Singletons/SingletonIcon'
import Record from './Record';

import RecordDetail from './RecordDetail';
import Action from '../../../../../fluid/Actions/ActionFactory';

const fieldSourceSpec = {
    beginDrag(props, monitor, component) {
        return {
            field_data : props.field_data,
            location : props.location
        }
    },
    endDrag(props, monitor, component) {
        return props.handleDropped({
            field_data: props.field_data,
            location : props.location
        }, props.field_type, monitor.getDropResult())
    },
    canDrag(props, monitor) {
        console.log("IFC :: Dragging : ", props.field_data)
        if (props.location === 'NewGroup') {
            return false
        }

        if (props.unsynced_fields.includes(props.field_data.record)) {
            return false
        }

        if (props.syncing_field === props.field_data.record) {
            return false
        } else {
            return true
        }
    }
}

function collect (connect, monitor) {
    return {
        connectDragSource : connect.dragSource(),
        connectDragPreview : connect.dragPreview(),
        isDragging : monitor.isDragging()
    }
}

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})

class RecordSummary extends Component {
    state = {
        anchorEl : null,
        record_in_focus : null
    }

    isUnsynced = () => {
        if (this.props.unsynced_fields.includes(this.props.field_data.record)) {
            return true
        } else {
            return false
        }
    }

    isSyncing = () => {
        if (this.props.field_data.record === this.props.syncing_field) {
            return true
        } else {
            return false
        }
    }

    isFocussed = () => {
        if (this.props.field_in_focus === null) {
            return false
        } else {
            if (this.props.field_in_focus.record === this.props.field_data.record) {
                return true
            } else {
                return false
            }
        }
    }

    createNewGroup = () => {
        let field_data = {
            field_data: this.props.field_data,
            location : this.props.location
        }
        this.props.create_new_group_from_field(field_data)
        this.handleMenu()
    }

    makeSingleton = () => {
        let field_data = {
            field_data: this.props.field_data,
            location : this.props.location
        }
        this.props.make_singleton(field_data)
        this.handleMenu()
    }

    highlightedName = () => {
        let start_index = this.props.field_data.matching_start_index
        let end_index = this.props.field_data.matching_end_index
        let text = this.props.field_data.field.split("").map((char, i) => {
            if (i >= start_index && i <= end_index) {
                return (
                    <mark style = {{backgroundColor : 'yellow', padding : 0}} key = {i}>{char}</mark>
                )
            } else {
                return (
                    <span>{char}</span>
                )
            }
        })

        return text
    }

    renderField = (field) => {
        if (this.props.field_type === 'singleton') {
            return (
            <TableCell
                    style = {{ 
                        border: 'none',
                        fontSize : 12
                    }}
            >
                <Typography style = {{fontSize : 12}} variant = 'body2'>{this.props.field_data.wv_field_list[field]}</Typography>
                {/* <Typography style = {{fontSize : 12}} variant = 'body2'>{this.props.highlight_name ? this.highlightedName() : this.props.field_data.field}</Typography> */}
                {this.props.field_data.global_mapped_field !== null &&
                    <Tooltip title = "Mapped to Global Field">
                        <Typography style = {{fontSize : 10, fontWeight : 600}} variant = 'caption' color = "primary" >{this.props.field_data.global_mapped_field }</Typography>
                    </Tooltip>
                }
            </TableCell>)
        } else {
            return (
                <TableCell
                    style = {{ 
                        border: 'none',
                        fontSize : 12
                    }}
                >
                    {/* {this.props.show_group_name ? 
                    <Fragment>
                        <Typography style = {{fontSize : 10}} variant = 'caption' color = 'textSecondary' display = 'inline'>{this.props.field_data.group_name + " / "}</Typography>
                        <Typography style = {{fontSize : 12}} variant = 'body2' display = 'inline'>
                            {this.props.highlight_name ? this.highlightedName() : this.props.field_data.field}
                        </Typography>
                    </Fragment>:  */}
                    <Typography style = {{fontSize : 12}} variant = 'body2'>
                        {this.props.field_data.wv_field_list[field]}
                        {/* {this.props.highlight_name ? this.highlightedName() : this.props.field_data.field} */}
                    </Typography>
                    {/* } */}
                </TableCell>
            )
        }
    }

    renderName = () => {
        if (this.props.field_type === 'singleton') {
            return (
            <TableCell
                    style = {{ 
                        border: 'none',
                        fontSize : 12
                    }}
            >
                <Typography style = {{fontSize : 12}} variant = 'body2'>{this.props.highlight_name ? this.highlightedName() : this.props.field_data.field}</Typography>
                {this.props.field_data.global_mapped_field !== null &&
                    <Tooltip title = "Mapped to Global Field">
                        <Typography style = {{fontSize : 10, fontWeight : 600}} variant = 'caption' color = "primary" >{this.props.field_data.global_mapped_field }</Typography>
                    </Tooltip>
                }
            </TableCell>)
        } else {
            return (
                <TableCell
                    style = {{ 
                        border: 'none',
                        fontSize : 12
                    }}
                >
                    {/* {this.props.show_group_name ? 
                    <Fragment>
                        <Typography style = {{fontSize : 10}} variant = 'caption' color = 'textSecondary' display = 'inline'>{this.props.field_data.group_name + " / "}</Typography>
                        <Typography style = {{fontSize : 12}} variant = 'body2' display = 'inline'>
                            {this.props.highlight_name ? this.highlightedName() : this.props.field_data.field}
                        </Typography>
                    </Fragment>:  */}
                    <Typography style = {{fontSize : 12}} variant = 'body2'>{this.props.highlight_name ? this.highlightedName() : this.props.field_data.field}</Typography>
                    {/* } */}
                </TableCell>
            )
        }
    }

    renderFieldCell = (cell) => {
        switch (cell) {
            case "$icon":
                return (
                    <TableCell
                        style = {{ 
                            border: 'none',
                            fontSize : 12
                        }}
                        align = 'center'
                    >
                        {this.isUnsynced() ? 
                        <Tooltip title = "Unsynced">
                            <SyncProblem style = {{color : '#ff9800'}} fontSize = 'small'/>
                        </Tooltip>:
                        this.isSyncing() ? 
                            <CircularProgress variant = 'indeterminate' color = 'primary' size = {20}/>
                        : this.props.field_type === 'singleton' ? <SingletonIcon/> :<RecordIcon field_display_name = {this.props.field_display_name}/>}
                    </TableCell>
                )
            
            // case "Name" :
            //     return this.renderName()

            case "$golden":
                return(
                    <TableCell
                        style = {{ 
                            border: 'none',
                            cursor: 'default'
                        }}
                        align = 'center'
                    >
                        {this.props.field_data.record_type === 'Golden' ? <Tooltip title='Golden Record'><Star style = {{color : '#f4d600'}} fontSize = 'small'/></Tooltip> : <Tooltip title='Delta Record'><ChangeHistory style = {{color : '#707070'}} fontSize = 'small'/></Tooltip>}
                    </TableCell>
                )

            case "$primary":
                return(
                    <TableCell
                        style = {{ 
                            border: 'none',
                        }}
                        align = 'center'
                    >
                        <IconButton 
                        disabled = {this.isSyncing()}
                        //style = {{padding : 0, margin : 0}} 
                        size = 'small' 
                        onClick = {(event) => {
                            event.stopPropagation();
                            event.nativeEvent.stopImmediatePropagation();
                            this.props.set_record_primary(this.props.field_data)
                        }}
                        >
                            {this.props.field_data.record_status === 'Primary' ? <Tooltip title='Primary Record'><Bookmark style = {{color : '#dc014e'}} fontSize = 'small'/></Tooltip> : <Tooltip title='Set Primary'><BookmarkBorder style = {{color : '#dc014e'}} fontSize = 'small'/></Tooltip>}
                        </IconButton>
                    </TableCell>
                )

            case "Score":
                return (
                    <TableCell
                        style = {{ 
                            border: 'none',
                            fontSize : 13,
                            fontWeight : 900,
                            color : '#03AD93'
                        }}
                        align = 'center'
                    >
                        {this.props.field_data.score.toFixed(2)}
                    </TableCell>
                )

            case "$options" :
                return (
                    <TableCell
                        style = {{ 
                            border: 'none',
                        }}
                        align = 'center'
                    >
                        <IconButton 
                        disabled = {this.isSyncing()}
                        style = {{padding : 0, margin : 0}} 
                        size = 'small' 
                        onClick = {(event) => {
                            event.stopPropagation();
                            event.nativeEvent.stopImmediatePropagation();
                            this.handleMenu(event)
                        }}
                        >
                            <MoreVert style = {{color : '#707070'}} fontSize = 'small'/>
                        </IconButton>
                    </TableCell>
                )
            default : 
                return this.renderField(cell)
        }
    }

    handleMenuClose = () => {
        this.setState({...this.state, anchorEl : null})
    }

    handleMenu = (event) => {
        if (this.state.anchorEl) {
            this.setState({...this.state, anchorEl : null})
        } else {
            this.setState({...this.state, anchorEl : event.currentTarget})
        }
    }

    renderMenu = () => {
        if (this.props.location === 'Singletons') {
            return (
                <Menu
                    id="field_menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleMenuClose}
                >
                    <MenuItem
                        disabled = {this.isUnsynced()}
                        onClick = {this.createNewGroup}
                    >New Group</MenuItem>
                </Menu>
            )
        }

        if (this.props.location !== 'NewGroup') {
            return (
                <Menu
                    id="field_menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleMenuClose}
                >
                    <MenuItem
                        disabled = {this.isUnsynced()}
                        onClick = {this.createNewGroup}
                    >New Group</MenuItem>
                    {this.props.field_type !== 'singleton' && <MenuItem
                        disabled = {this.isUnsynced()}
                        onClick = {this.makeSingleton}
                    >Make Singleton</MenuItem>}
                </Menu>
            )
        } else {
            return (
                <Menu
                    id="field_menu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleMenuClose}
                >
                    <MenuItem onClick = {this.removFieldFromNewGroup}>Remove Field</MenuItem>
                </Menu>
            )
        }
    }

    removFieldFromNewGroup = () => {
        this.setState({...this.state, anchorEl: null}, () => this.props.remove_field(this.props.field_data))
    }

    renderFieldRows = () => {
        let {field_data} = this.props
        const { isDragging, connectDragSource } = this.props
        const opacity = isDragging ? 0 : 1
        console.log('IRC :: Records : ', this.props.field_data)
        return (
            <TableRow
                style = {{
                    backgroundColor : this.isSyncing() ? 'FAFAFA' : '#FFFFFF',
                    padding : '10px',
                    boxShadow : this.isUnsynced() ? "" : this.isSyncing() ? '' : '1px 2px 12px -9px rgba(0,0,0,0.49)',
                    width : '90%',
                    cursor : this.isSyncing() ? '' : 'pointer',
                    opacity : opacity
                }}
                onClick = {() => {
                    this.props.focus_field(this.props.field_data)
                    this.props.focus_record(this.props.field_data)
                }}
                ref = {instance => connectDragSource(findDOMNode(instance))}
                onDrag = {(event) => {
                    event.stopPropagation();
                    event.nativeEvent.stopImmediatePropagation();
                }}
            >
                {this.props.columns.map(cell => {
                    return this.renderFieldCell(cell)
                })}
                {/* <TableCell style={{ margin: 0, padding : 0}}>
                    <Card>
                        <CardActionArea>
                            <CardContent>
                                <div style={{display: 'flex', flexDirection:'row'}}>
                                    <div style={{display: 'flex', flexDirection:'column', flexGrow : 1}}>
                                        <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center', marginBottom : '5px'}}>
                                            {this.props.field_data.group_id !== -1 && <GroupIcon/>}
                                            {this.props.field_data.group_id !== -1 && <Typography style = {{marginLeft : '3px', marginRight : '5px'}} variant = 'overline' color ='textPrimary'>{this.props.field_data.group_name}</Typography>}
                                            {this.props.field_data.group_id !== -1 && <Typography style = {{marginRight : '5px'}} variant = 'caption' color ='primary'>/</Typography>}
                                            {this.props.field_data.group_id !== -1 ? <RecordIcon/> : <SingletonIcon/>}
                                            <Typography style = {{marginLeft : '3px', marginRight : '5px'}} variant = 'overline' color ='textPrimary'>{this.props.field_data.record_id}</Typography>
                                            <Typography style = {{marginLeft : '60%', marginRight : '5px'}} variant = 'overline' color ='textPrimary'>Score:</Typography>
                                            <Typography style = {{marginLeft : '3px', marginRight : '5px', border: 'none', fontSize : 12, fontWeight : 900, color : '#03AD93'}} variant = 'overline' color ='textPrimary'>{this.props.field_data.score.toFixed(2)}</Typography>
                                        </div>
                                        {
                                            Object.keys(this.props.field_data.wv_field_list).map((field)=> {
                                                return (
                                                    <div style={{padding:'5px'}}>
                                                        <Typography variant = 'subtitle2' color ='textSecondary'>{field}</Typography>
                                                        <Typography variant = 'body' color ='textPrimary'>{this.props.field_data.wv_field_list[field]}</Typography>
                                                    </div>
                                                ) 
                                            })
                                        }  
                                    </div>  
                                    <div>
                                        <IconButton 
                                            disabled = {this.isSyncing()}
                                            style = {{padding : 0, margin : 0}} 
                                            size = 'small' 
                                            onClick = {(event) => {
                                                event.stopPropagation();
                                                event.nativeEvent.stopImmediatePropagation();
                                                this.handleMenu(event)
                                            }}
                                            >
                                                <MoreVert style = {{color : '#707070'}} fontSize = 'small'/>
                                        </IconButton>
                                    </div> 
                                </div>  
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </TableCell> */}
            </TableRow>   
        )
    }

    render() {
        const { classes } = this.props
        const { isDragging, connectDragSource } = this.props
        console.log("summary: ", this.props.fields_for_summary)
        console.log("syncing field: ", this.props.syncing_field)
        return (
            <ThemeProvider theme = {blue_theme}>
                    {this.renderFieldRows()}
                    {this.renderMenu()}
            </ThemeProvider>
        );
    }
}
 
export default (withStyles(styles)(DragSource('record', fieldSourceSpec, collect)(RecordSummary)))